import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { IOutlierReasonData, OutlierReasonDialogComponent } from 'src/app/modals/outlier-reason-dialog/outlier-reason-dialog.component';
import { Sample } from 'src/app/models/sample.model';
import { RiskRegisterService } from 'src/app/services/risk-register.service';
import { SampleService } from 'src/app/services/sample.service';

@Injectable({ providedIn: 'root' })
export class SampleOutlierService {
    constructor(
        private dialog: MatDialog,
        private sampleService: SampleService,
        private riskRegisterService: RiskRegisterService,
    ) {}

    // Emits the trimmed reason once the user saves one; completes without emitting on cancel or a blank reason.
    promptOutlierReason(currentReason?: string | null): Observable<string> {
        return this.dialog
            .open(OutlierReasonDialogComponent, {
                data: { outlierReason: currentReason || '' } as IOutlierReasonData,
                width: '500px',
            })
            .afterClosed()
            .pipe(
                filter((reason): reason is string => (reason?.trim()?.length ?? 0) > 0),
                map((reason) => reason.trim()),
            );
    }

    setOutlier(sampleId: string, payload: Pick<Sample, 'isOutlier' | 'outlierReason'>): Observable<unknown> {
        return this.sampleService.patch(sampleId, payload);
    }

    // The register statistics are only recomputed on update, so re-save it unchanged after an outlier change.
    recalculateRegister(riskRegisterId: string): Observable<unknown> {
        return this.riskRegisterService
            .getRiskRegister(riskRegisterId)
            .pipe(switchMap((register) => this.riskRegisterService.update({ ...register, riskRegisterControls: null })));
    }
}
